import * as React from 'react';
import { Dispatch } from "redux";
import bindAllOfThis from "src/utils/BindThisHelper";
import { Steps, Dropdown, Menu } from 'antd';
import { Planet, Planets } from "src/constants/Planets";
import { ReduxStoreModel } from "src/redux/ReduxModel";
import { connect } from "react-redux";
import './Box.less';
import { MissionState } from "src/redux/CheckpointReducer";
import { Checkpoints } from "src/constants/Checkpoints";
import SimpleCheckpointStatusDTO from "src/models/frontend/redux/SimpleCheckpointStatusDTO";
import CheckpointAction from "src/redux/CheckpointActions";
import { Redirect } from "react-router";
import Routes from "src/core/Routes";
import { ClickParam } from "antd/lib/menu";
import CheckpointStatusDTO from "src/models/frontend/redux/CheckpointStatusDTO";
import { Translate } from "react-localize-redux";
import TranslateApi from 'src/utils/TranslateHelper';
import { numKeys } from 'src/constants/KeyboardNumKeys';

const { Step } = Steps;
const IncompletePlanetPath = require("/src/assets/qci/sprites/planets/incomplete-small.png");

interface PlanetBoxProps {
    // From Redux
    Mission: MissionState;
    updateMissionStatus: (request: SimpleCheckpointStatusDTO) => void;
    startReplay: (start: CheckpointStatusDTO, end: CheckpointStatusDTO, returnLocation: string) => void;
}
interface PlanetBoxState {
    currentPlanet: Planet;
    furthestPlanet: Planet;
    requireRedirect: boolean;
    keyboardSelectedPlanet: Planet;
}

class PlanetBox extends React.Component<PlanetBoxProps, PlanetBoxState> {
    private sortedPlanets: Planet[];

    constructor(props: PlanetBoxProps) {
        super(props);
        bindAllOfThis(this, PlanetBox.prototype);

        this.sortedPlanets = [...Planets.All.sort((a, b) => a.order - b.order)]; // Ensure order

        this.state = {
            currentPlanet: null,
            furthestPlanet: null,
            requireRedirect: false,
            keyboardSelectedPlanet: null
        };
    }

    componentDidMount(): void {
        this.deriveStateFromProps(this.props);
        document.addEventListener("keydown", this.handleKeyPress, false);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyPress);
    }

    handleKeyPress(event): void {
        let selectedPlanet = Planets.All.find((planet) => planet.name === event.key.toUpperCase());
        if (selectedPlanet) {
            this.handlePlanetKeyPress(selectedPlanet);
        }
        else if (this.state.keyboardSelectedPlanet && ["1", "2", "3", "4"].includes(event.key)) {
            this.planetMenuSelected(event.key, this.state.keyboardSelectedPlanet.id);
        }
    }

    handlePlanetKeyPress(selectedPlanet: Planet): void {
        this.setState({ keyboardSelectedPlanet: selectedPlanet });
        let planetImg = document.getElementById('planet' + selectedPlanet.name);
        planetImg.click();
        let planetUL = document.getElementById('menu' + selectedPlanet.name);
        let menu = planetUL.parentElement;
        menu.style.left = planetImg.getBoundingClientRect().left + 10 + 'px';
        menu.style.top = '34px';
    }

    componentWillReceiveProps(nextProps: PlanetBoxProps) {
        if (this.props.Mission.current.planetId !== nextProps.Mission.current.planetId ||
            this.props.Mission.furthest.planetId !== nextProps.Mission.furthest.planetId) {
            // Update the translation array
            this.deriveStateFromProps(nextProps);
        }
    }

    deriveStateFromProps(newProps: PlanetBoxProps) {
        let currentPlanet = Planets.FindById(newProps.Mission.current.planetId);
        let furthestPlanet = Planets.FindById(newProps.Mission.furthest.planetId);

        this.setState({
            currentPlanet: currentPlanet,
            furthestPlanet: furthestPlanet,
        } as PlanetBoxState);
    }

    private planetMenuOnClick(e: ClickParam, selectedPlanet: Planet) {
        this.planetMenuSelected(e.key, selectedPlanet.id);
    }

    private planetMenuSelected(selection: string, selectedPlanetId: number) {
        let replayStart: CheckpointStatusDTO = {
            planetId: selectedPlanetId,
            checkpointId: 1,
            stepId: 1
        };
        let replayEnd: CheckpointStatusDTO = {
            planetId: selectedPlanetId,
            checkpointId: 2,
            stepId: 1
        };

        switch (selection) {
            case "1":
                replayStart.checkpointId = Checkpoints.Landing.id;
                replayEnd.checkpointId = Checkpoints.BetweenPlanets.id;
                break;
            case "2":
                replayStart.checkpointId = Checkpoints.Game.id;
                replayEnd.checkpointId = Checkpoints.PostGame.id;
                break;
            case "3":
                replayStart.checkpointId = Checkpoints.Video.id;
                replayEnd.checkpointId = Checkpoints.PreGame.id;
                break;
            case "4":
                replayStart.checkpointId = Checkpoints.Activity.id;
                replayEnd.checkpointId = Checkpoints.Badge.id;
                break;
            default:
                break;
        }

        this.props.startReplay(replayStart, replayEnd, Routes.STUDENT_HOME);
        this.setState({
            requireRedirect: true
        });
    }

    addClass(): void {

    }

    private stepsProgress(iconDot: any, { index, status, title, description }) {
        let selectedPlanet = this.sortedPlanets[index];
        let isComplete = this.state.furthestPlanet.id - 1 >= index;
        if (isComplete) {
            let menu = <Menu id={`menu${selectedPlanet.name}`} onClick={(e) => this.planetMenuOnClick(e, selectedPlanet)} onOpenChange={(e) => console.warn(e)} onSelect={(e) => console.warn(e)}>
                <Menu.Item tabIndex={2} key="1">
                    1: <Translate id="student.planetBox.restart" />
                </Menu.Item>
                <Menu.Item tabIndex={2} key="2">
                    2: <Translate id="student.planetBox.game" />
                </Menu.Item>
                <Menu.Item tabIndex={2} key="3">
                    3: <Translate id="student.planetBox.video" />
                </Menu.Item>
                <Menu.Item tabIndex={2} key="4">
                    4: <Translate id="student.planetBox.activity" />
                </Menu.Item>
            </Menu>;

            return <div>
                <Dropdown overlay={menu} trigger={['click', 'contextMenu']} >
                    <img id={`planet${selectedPlanet.name}`} tabIndex={2} className="planet-icon" alt={`Planet ${selectedPlanet.name}`} src={selectedPlanet.iconPath} height="100%" width="100%" />
                </Dropdown>
            </div>;
        }

        return <img className="planet-icon" alt={`Planet ${selectedPlanet.name}`} src={IncompletePlanetPath} height="100%" width="100%" />;
    }

    private renderPlanets() {
        if (this.state.currentPlanet == null) {
            return null;
        }

        let planetTranslation = TranslateApi.translate("common.planet"); //HACK: shouldn't use TranslateAPI, revisit and reconfigure to use LocalizeContextProps w/ this.props.translate
        // Notes: Will need to have some sort of index. I think i can get a list of selected planets in the plants constants file
        return <Steps size="small" current={this.state.currentPlanet.id - 1} progressDot={this.stepsProgress}>
            {
                this.sortedPlanets.map((planet, index) => {
                    return <Step key={planet.name + index}
                        icon={<div />} // This just needs to be something
                        title={`${planetTranslation} ${planet.name}`} />;
                })
            }
        </Steps>;
    }

    render() {
        let planetCode: string = (this.state.currentPlanet || { name: "" }).name.toLowerCase() as string;
        let className = `box-component planet-${planetCode}`.toLowerCase();
        if (this.state.requireRedirect) {
            // I am mostly sure this is reverted, but i cannot be sure anymore with this application
            this.setState({
                requireRedirect: false
            });
        }

        return <div id={"planetBox"} className={className}>
            {this.renderPlanets()}
            {this.state.requireRedirect ? <Redirect to={Routes.STUDENT_HOME}/> : null}
        </div>;
    }
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
    return {
        updateMissionStatus: (request: SimpleCheckpointStatusDTO) => CheckpointAction.UpdateCurrentUserStatus(dispatch, request),
        startReplay: (start: CheckpointStatusDTO, end: CheckpointStatusDTO, returnLocation: string) => CheckpointAction.StartReplay(dispatch, start, end, returnLocation),
    };
}

function mapStateToProps(state: ReduxStoreModel) {
    return {
        Mission: state.Mission,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanetBox);



// WEBPACK FOOTER //
// ./src/components/mission/PlanetBox.tsx